<template>
  <tr @click.stop="clickRow(index)"
      v-click-outside="hideEditSoa"
      @mouseenter="setActiveRow(index)"
      @mouseleave="activeRow = false, deleteConfirmIndex = false"
      :class="{'bb-table-body-row_active':activeRow === index}"
      class="bb-table-body-row"
  >
    <td class="bb-table-body__item">
      <div class="bb-table-body-row__after" :ref="'bbRowAfter' + index"/>
      <div class="bb-table-body-row__status"
           :class="[`bb-table-body-row__status_${(soaStatus === 1) ? 'open' :
                                                         (soaStatus === 2) ? 'completed' :
                                                         (soaStatus === 3) ? 'consumed' :
                                                         'none'}`]"/>
    </td>
    <!-- DATE -->
    <td class="bb-table-body__item">
      <DateColumn :soa="soa"
                  :index="index"
                  :editSoaIndex="editSoaIndex"
                  @setDate="setSoaDate"
                  :dateEdit="soa.date"/>
    </td>
    <!-- DESCRIPTION -->
    <td class="bb-table-body__item">
      <DescriptionColumn :client="client"
                         :editSoaIndex="editSoaIndex"
                         :index="index"
                         :soa="soa"
                         :newSoa="newSoa"
                         @createSoa="createSoa"
                         @change="setInvoiceToSoa"
                         @openProforma="openProforma"
                         @changeBalance="changeBalance"
                         @setDescription="setDescription"/>
    </td>
    <!-- TAX INV NO. -->
    <td class="bb-table-body__item"
        @click="openBalanceInvoice">
      <TaxInvNoColumn :checkedInvoice="checkedInvoice"
                      :soa="soa"
                      :index="index"
                      @openFile="openFile"
                      :soaList="soaList"/>
    </td>
    <!-- OUTGOING -->
    <td class="bb-table-body__item bb-table-outgoing">
      <OutgoingColumn :soa="soa"
                      :editSoaIndex="editSoaIndex"
                      :index="index"/>
    </td>
    <!-- BREAKDOWN -->
    <td class="bb-table-body__item bb-table-outgoing">
      <BreakdownColumn :error="error"
                       @changeInput="changeInput"
                       @focusInput="focusInput"
                       @hideEditSoa="hideEditSoa"
                       @editSoa="createSoa"
                       :soa="soa"
                       :index="index"
                       :newSoa="newSoa"
                       :notNewSoa="notNewSoa"
                       :disableInput="disableInput"
                       :creatingSoa="creatingSoa"
                       :includesText="includesText"
                       :editSoaIndex="editSoaIndex"
                       :notIncludesText="notIncludesText"
                       :extraModel="soa.extra"
                       :breakdownModel="soa.breakdown"/>
    </td>
    <!-- INCOMING -->
    <td class="bb-table-body__item bb-table-incoming">
      <IncomingColumn :model="soa.incoming"
                      :editSoaIndex="editSoaIndex"
                      @focusInput="focusInput"
                      :index="index"
                      :soa="soa"
                      :disableInput="disableInput"
                      @createSoa="createSoa"
                      @hideEditSoa="hideEditSoa"
                      @changeInput="changeInput"
                      :error="error"/>
    </td>
    <!-- MODE OF PAYMENT -->
    <td class="bb-table-body__item bb-table-body__item_input bb-table-body__item_invoice">
      <ModeOfPaymentColumn :list="list"
                           :soa="soa"
                           :index="index"
                           :editSoaIndex="editSoaIndex"
                           :modeOfPayment="soa.modeOfPayment"
                           :expenseCategory="expenseCategory"/>
    </td>
    <!-- INCLUDE IN GENERAL EXPENSES -->
    <td class="bb-table-body__item">
      <IncludeInGeneralExpenses :name="soa"
                                :value="editSoaIndex !== index ?
                                !soa.excludeExpenses : !soa.excludeExpenses"
                                :disable="editSoaIndex !== index || soa.isAutoSoa"
                                v-if="checkOutgoing(soa, index)"/>
    </td>
    <!-- BALANCE -->
    <td class="bb-table-body__item">
      <ButtonColumn :disable="disable"
                    :index="index"
                    :soa="soa"
                    :editSoaIndex="editSoaIndex"
                    @createSoa="createSoa"
                    :buttonText="buttonText"/>
    </td>
    <!-- FILE -->
    <td class="bb-table-body__item">
      <div class="bb-row-soa__toolbar">
        <Upload class="bb-row-soa__file"
                v-if="soa.uploadFile || editSoaIndex === index"
                :multiple="false"
                :files="soa.uploadFile ? [soa.uploadFile] : []"
                :view="soa.uploadFile"
                :upload="!disable && editSoaIndex === index"
                :item="soa"
                @statusUpload="setDisabledSave"
                @view="openFile"
                @upload="uploadFile"
                @delete="deleteFile"/>
        <Toolbar v-if="activeRow === index && editSoaIndex !== index && !soa.isConsumed"
                 :delete-index="deleteConfirmIndex"
                 :index="index"
                 :item="soa"
                 :forSoa="forSoa"
                 :no-delete="soa.isAutoSoa || soa.isCreditNote || soa.isShortfall || soa.isWriteOff"
                 :no-edit="soa.isCreditNote || soa.isShortfall || soa.isWriteOff"
                 @openEdit="openEditSoa"
                 @deleteOpen="deleteConfirmIndex = index"
                 @deleteClose="deleteConfirmIndex = false"
                 @deleteItem="deleteItem"/>
        <DoubleDelete v-if="openDelete === index"
                      :id="soa.id"
                      :password="passwordSoaDelete"
                      :title="soa.description"
                      @close="closeDelete"
                      @delete="deleteSoa"/>
      </div>
    </td>
  </tr>
</template>

<script>
import DateColumn from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/DateColumn'
import DescriptionColumn
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/DescriptionColumn'
import BreakdownColumn
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/BreakdownColumn'
import IncomingColumn
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/IncomingColumn'
import ModeOfPaymentColumn
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/ModeOfPaymentColumn'
import IncludeInGeneralExpenses
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/IncludeInGeneralExpenses'
import TaxInvNoColumn
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/TaxInvNoColumn'
import ButtonColumn from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/ButtonColumn'
import OutgoingColumn
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/OutgoingColumn'
import validateNum from '@/mixin/validateNum'
import DoubleDelete from '@/components/Main/DoubleDelete/DoubleDelete'
import Upload from '@/components/Main/Upload/Upload'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import {passwordSoaDelete} from '@/constants/passwordForDelete'
import _ from 'lodash'
export default {
  name: 'RowSoa',
  components: {
    ButtonColumn,
    DateColumn,
    TaxInvNoColumn,
    DescriptionColumn,
    BreakdownColumn,
    Toolbar,
    DoubleDelete,
    ModeOfPaymentColumn,
    IncludeInGeneralExpenses,
    IncomingColumn,
    OutgoingColumn,
    Upload
  },
  mixins: [validateNum],
  computed: {
    soaStatus () {
      const outgoing = _.get(this.soa, 'outgoing', 0)
      const incoming = _.get(this.soa, 'incoming', 0)
      const isAutoSoa = _.get(this.soa, 'isAutoSoa', false)
      if (incoming > 0 && outgoing === 0 && isAutoSoa) {
        return _.get(this.soa, ['invoice', 'soaStatus'], 0)
      }
    }
  },
  props: [
    'buttonText',
    'disableInput',
    'editSoaIndex',
    'soa',
    'client',
    'disable',
    'notNewSoa',
    'index',
    'checkedInvoice',
    'soaList',
    'refs',
    'error',
    'newSoa',
    'creatingSoa',
    'rowActive',
    'includesText',
    'notIncludesText',
    'list',
    'expenseCategory'
  ],
  data () {
    return {
      activeRow: this.rowActive,
      deleteConfirmIndex: false,
      openDelete: false,
      forSoa: true,
      passwordSoaDelete: passwordSoaDelete
    }
  },
  methods: {
    hideEditSoa () {
      this.$emit('hideEditSoa')
    },
    createSoa () {
      this.$emit('createSoa')
    },
    changeInput (type, value) {
      this.$emit('changeInput', type, value)
    },
    focusInput (type) {
      this.$emit('focusInput', type)
    },
    setInvoiceToSoa ({service, invoice, overPaid}) {
      this.$emit('change', {service: service, invoice: invoice, overPaid: overPaid})
    },
    setDescription (description) {
      this.$emit('setDescription', description)
    },
    changeBalance () {
      this.$emit('changeBalance')
    },
    clickRow (index) {
      if (this.editSoaIndex !== index) {
        this.hideEditSoa()
      }
    },
    openBalanceInvoice () {
      this.$emit('openBalance', this.soa)
    },
    checkOutgoing (soa, index) {
      if (soa.isAutoSoa || soa.isCreditNote) return
      if (this.editSoaIndex === index) {
        return this.soa.outgoing > 0
      }
      if (this.editSoaIndex !== index) {
        return soa.outgoing > 0
      }
      return this.validateNum(this.soa.breakdown) > 0
    },
    setActiveRow (index) {
      this.activeRow = index
      const widthTable = _.get(this.refs, 'bbSoaTable.$el.offsetWidth', false)
      const afterElement = _.get(this.$refs, `bbRowAfter${index}`, [])
      if (widthTable && afterElement) {
        afterElement.style.width = widthTable + 'px'
        afterElement.style.left = -4 + 'px'
      }
    },
    openProforma (event, soa) {
      this.$emit('openProforma', event, soa)
    },
    setSoaDate (date) {
      this.$emit('setDate', date)
    },
    openEditSoa (index, item) {
      this.$emit('openEdit', {item, index})
    },
    setDisabledSave (val) {
      this.$emit('statusUpload', val)
    },
    deleteItem () {
      this.openDelete = this.index
      this.$emit('openDelete')
    },
    closeDelete () {
      this.openDelete = false
      this.$emit('closeDelete', this.openDelete)
    },
    deleteSoa (id) {
      this.openDelete = false
      this.deleteConfirmIndex = false
      this.$emit('delete', id)
    },
    openFile (file, item) {
      this.$emit('view', file, item)
    },
    uploadFile (files, item) {
      this.$emit('upload', files, item)
    },
    deleteFile (file, item) {
      this.$emit('remove', file, item)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";

  .bb-row-soa {
    @include global-font;

    &__toolbar {
      display: flex;
    }

    &__file {
      margin-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/RowSoa.vue